import React, { PureComponent } from 'react';
import { Progress, Table, Row } from 'reactstrap';
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, ComposedChart } from 'recharts';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import getTooltipStyles from '../../../../../shared/helpers';
import Panel from '../../../../../shared/components/Panel';
import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
	_getBuildingURL,
} from '../../../../../shared/helpers/utils';
import{
	_axiosCall,
} from '../../../../../shared/helpers/apicalls';
import { getDefaultChartColors } from '../../../../../shared/helpers';

const apiURL = process.env.API_ROOT + '/query/';


let bedTypes = [];

class ListingTrends extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    themeName: PropTypes.string.isRequired,
  };
 
  
  constructor() {
    super();
    this.state = {
      data: false,
    };
  }
   _setbedrooms = (bedrooms) => {
	  
	  let stats = {
		  'studio':0,
		  '1 bed':0,
		  '2 bed':0,
		  '3 bed':0,
		  '4+ bed':0,
	  };
	  for(let i = 0; i < bedrooms.length; i++) {
	  	  const bedroom = bedrooms[i];
	  	  
		  if(bedroom.val === 0) {
			  stats['studio'] = bedroom.count;
			  bedTypes.push('0_studio');
		  }else if(bedroom.val > 0){
			  stats[bedroom.val+' bed'] = bedroom.count;
			   bedTypes.push(bedroom.val+' bed');
		  }/*
else if(bedroom.val >= 4){
			  stats['4+ bed'] += bedroom.count;
			   bedTypes.push('4+ bed');
		  }
*/
		  
	  }	
	  bedTypes = [...new Set(bedTypes)];  
	  return stats;
	  
  }

  
  _getListingTrend = async (buildingRes) => { 
		const addressQ = buildingRes.alternate_addresses.join('" OR "');					
		const q = `alternate_addresses:("${addressQ}") AND (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}")`;
		const fq = [
			"deleted:false",
			"listing_type:sale",
			"price:[100000 TO *]",
			`source_namespace:(${process.env.LISTING_NAMESPACES})`
		]
		let axiosData = {
			url: apiURL + "search-listings",
			method: "post",
			query: {
				q: q,
				sort: "solr_updated_date desc",
				wt: "json",
				fq: fq,
				rows: 1,
				"json.facet": {
	            listing_price: {
	              range: {
	                field: "active_date_start",
	                start: buildingRes.sales_start_date,
	                end: "NOW",
	                gap: "+1MONTH",
	                facet: {
	                  by_bedrooms: {
	                    type: "terms",
	                    field: "bedrooms",
	                    limit: 50,
	                    facet: {
	                      average: "avg(price)"
	                    }
	                  },
	                  avg_price: "avg(price)",
	                }
	              }   
			    },
			  }
				
			}
		};

		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				// console.log('Chart Data', res);
				//this.setState({statsRes: res.facets, unitsRes: res.docs});
				const { buckets } = res.facets.listing_price;	
				const data = [];
				for(let i = 0; i < buckets.length; i++) {
					const bucket = buckets[i];
					const bedrooms = bucket.by_bedrooms && bucket.by_bedrooms.buckets && bucket.by_bedrooms.buckets[0] ? bucket.by_bedrooms.buckets : [];
					const bedroomStats = this._setbedrooms(bedrooms);
					console.log(bedroomStats);
					let item = {
						month : moment(bucket.val).format('MM/YYYY'),	
						avg_price: bucket.avg_price ? bucket.avg_price : data[i-1].avg_price,					
					}; 
					
					
					item = Object.assign(item, bedroomStats);
					data.push(item);
				}
				this.setState({ data: data });
			})
			.catch(error => {
				console.log("error: " + error);
			});

		// console.log(formattedData)
		return formattedData;
	};

  
  componentDidMount() {	
	const { buildingRes } = this.props;  
	this._getListingTrend(buildingRes);
  }
  
  render() {
      const { t, dir, themeName, lmi } = this.props;    
      const { data } = this.state;
	  if(!data){
		  return null;
	  }
	console.log(bedTypes);
	  return (
		  <Panel 
		  	md={12}
		  	lg={12}
		  	xl={12} 
		  	title={'New Listing Volume'}
		  	subhead={'Number of monthly new listings by bedroom since sales started'}
		  >
		    <div dir="ltr">
		      <ResponsiveContainer height={350} className="dashboard__area">
		        <BarChart data={data} margin={{ top: 0, left: -20, bottom: 20, right:20 }}>
			       
		           <XAxis dataKey="month" tickLine={false} reversed={dir === 'rtl'} dx={5} angle={45} tickSize={20} height={60} tickMargin={10} />
			       <YAxis  yAxisId="left" tickLine={false} tickLine={false}  orientation={'left'} tickFormatter={value => [new Intl.NumberFormat('en').format(value)].join('')} />
			      {/* <YAxis yAxisId="right" 
			        tickLine={false} 
			        orientation={'right'} 
			       	tickFormatter={value => ['$', new Intl.NumberFormat('en').format(value)].join('')}/> */}
			       <Tooltip/>
			       <Legend />
			       <CartesianGrid vertical={false}/>
			      {/* <Area yAxisId="right" name="Average Price" type="monotone" dataKey="avg_price" fill="#BFC4D1" stroke="#171f26" strokeWidth={2} fillOpacity={0.1} /> */}
			       {bedTypes.sort().map((key, i) => {
				       return <Bar dataKey={key.replace('0_', '')} yAxisId="left" stackId="a" fill={getDefaultChartColors[i]} />
			       })}
			       
			        

			      
			      </BarChart>
		      </ResponsiveContainer>
		    </div>
		  </Panel>
		);
	}
}

export default connect(state => ({
  rtl: state.rtl,
  dir: PropTypes.string.isRequired,
  theme: state.theme,
}))(withTranslation('common')(ListingTrends));
